module.exports = __webpack_public_path__ + "static/media/link-events.bd11ea3a.png";